import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import LOGO from '../../assets/img/private.png';
import s from './header.module.scss';
export const Head = ({ selectedLanguage, setSelectedLanguage }) => (_jsx("header", { className: s.header, children: _jsxs(Link, { to: 'https://t.me/tonprivatecoin', target: "_blank", className: s.headerLogo, children: [_jsx("img", { src: LOGO, alt: "logo" }), " PRIVATE"] }) }));
